import styled from 'styled-components';
import * as Yup from 'yup';
import { api } from 'src/Basic/ApiFetch';
import { getGlobalServerConfig } from 'src/Route/RootMiddleware';
const apiUrl = getGlobalServerConfig().backEndUrl.get();
/**
 * 查詢
 * @param {*} requestData 
 * @returns 
 */
export const getCaseProgress = async (requestData) => {
    let url = apiUrl + 'CaseProgressQuery/GetQueryData';
    let response = await api.Post(url, JSON.stringify(requestData), null, false);
    let data = [];
    if (response.ok) {
        data = await response.json();
    }
    return data;
}
/**
 * 檢查驗證碼
 * @param {*} requestData 
 * @returns 
 */
export const CheckCaptcha = async (requestData) => {
    let url = apiUrl + 'CaseProgressQuery/CheckCaptcha';
    let response = await api.Post(url, JSON.stringify(requestData), null, false);
    let data = [];
    if (response.ok) {
        data = await response.json();
    }
    return data;
}
//欄位驗證
export const dsicValidateField = Yup.object()
    .shape({
        DocNo: Yup.string().nullable(),
        postOfficeBarcode: Yup.string().nullable(),
        diliverBarcode: Yup.string().nullable(),
        captcha: Yup.string().required('請輸入驗證碼'),
        OrgSys: Yup.string().required(),
    })
    .test('onlyone', null, function (values) {
        const { DocNo, postOfficeBarcode, diliverBarcode } = values;
        const filledCount = [DocNo, postOfficeBarcode, diliverBarcode].filter(
            (v) => v && v.trim() !== ''
        ).length;

        if (filledCount !== 1) {
            return this.createError({
                path: 'onlyone', // 
                message: '收文文號、郵局條碼編號、快遞條碼編號三者擇一必填',
            });
        }
        return true;
    });

export const olapValidateField = Yup.object().shape({
    SendNo: Yup.string().required('請輸入線上申辦送件編號'),
    captcha: Yup.string().required('請輸入驗證碼'),
    OrgSys: Yup.string().required()
});

export const niaValidateField = Yup.object().shape({
    OrgNam: Yup.string(),
    IcNo: Yup.string(),
    captcha: Yup.string().required('請輸入驗證碼'),
    OrgSys: Yup.string().required()
}).test(
    'one-of-required',
    '邀請單位或團號擇一填寫即可',
    function (value) {
        const { OrgNam, IcNo } = value || {};
        // 當兩者皆無輸入時，回傳驗證失敗
        if (!OrgNam?.trim() && !IcNo?.trim()) {
            return this.createError({
                path: 'OrgNam', // 錯誤訊息串接在 OrgNam 欄位
                message: '請輸入邀請單位或團號'
            });
        }
        return true;
    }
);



/**
 * 去掉本來from table 裡的border 符合需求顯示
 */
export const StyledSearchTable = styled.table`
border: none;
width: 50%;
margin: 0 25%;

tr td {
    border: none;
}

tr td input {
        height: auto !important;
        margin: 1px 0px 0px 0px !important;
}
`
/**
 * 符合需求顯示table樣式
 */
export const StyledListTable = styled.table`
    border-color: var(--bs-table-border-color);
    margin-bottom: 1rem;
    vertical-align: top;
    width: 100%;
    color: #121212;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin: 0;
    tr{
        vertical-align: middle;
        border-bottom: 1px solid #bdbdbd !important;
    }
    tr th {
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        text-align: left;
        border: 0 solid;
        border-color: inherit;
        height: auto;
        padding: .5rem;
    }
    tr td {
        height: 69px;
        padding: .5rem;
    }
`